import { ColorEnum } from '@/constants/color'
import styles from '@/features/common/components/Overview/parts/ProductItem/styles'
import { TextSize } from '@/features/common/components/Overview/parts/ProductItem/types'
import NoteIcon from '@/features/ui/icons/components/NoteIcon'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { View } from 'react-native'

interface NoteRowProps {
    note?: string
    textSize: TextSize
}

const NoteRow: FC<NoteRowProps> = ({ note, textSize }) => {
    if (!note) return null

    return (
        <View style={styles.noteRow}>
            <NoteIcon width={16} height={16} fill={ColorEnum.YELLOW_600} />
            <Typography.Description size={textSize} font="regular" style={styles.noteText}>
                {note}
            </Typography.Description>
        </View>
    )
}

export default NoteRow
